/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
// Context

// eslint-disable-next-line react/jsx-props-no-spreading
export default function EngagementOptionModal({
  enagementModal,
  setEngagementModal,
  engagementOptions,
  handleChangeMoe,
}) {
  const handleClose = () => {
    setEngagementModal(false);
  };
  return (
    <Dialog onClose={handleClose} open={enagementModal}>
      <DialogTitle>Choose Mode of Engagement</DialogTitle>
      <List sx={{ pt: 0 }}>
        {engagementOptions?.map((row) => (
          <ListItem disableGutters>
            <ListItemButton onClick={() => handleChangeMoe(row)}>
              <ListItemText primary={row?.description} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}

EngagementOptionModal.defaultProps = {
  enagementModal: false,
  setEngagementModal: () => {},
  engagementOptions: [],
  handleChangeMoe: () => {},
};

EngagementOptionModal.propTypes = {
  enagementModal: PropTypes.bool,
  setEngagementModal: PropTypes.func,
  engagementOptions: PropTypes.array?.isRequired,
  handleChangeMoe: PropTypes.func,
};
